var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDormit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#7140FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8182 65.3261L34.2386 62.0079L71.8635 71.2261L43.7439 78.5292L15.8182 65.3261Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3233 26.9506L35.3633 23.0736L28.8587 71.3969L41.8355 63.9703L37.3233 26.9506Z",
    fill: "#CD9961"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3236 26.9512L35.3636 23.0742L31.7665 49.8058L36.6114 24.1044L37.3236 26.9512Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6661 62.7987L28.8529 71.3868L43.5655 78.5757L42.6661 62.7987Z",
    fill: "#BE8E5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3632 23.0731L66.9018 26.5616L75.695 72.3313L43.5669 78.576L35.3632 23.0731Z",
    fill: "#E9BB89"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4099 30.7717L65.1572 31.4389L68.5609 34.5708L37.1 33.6637L37.4099 30.7717Z",
    fill: "#BF9970"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0843 33.6527L68.2817 34.3769L69.8707 35.839C70.4987 36.4168 70.0752 37.4624 69.2232 37.4378L40.5746 36.6118C40.349 36.6053 40.1335 36.5163 39.9688 36.3616L37.0843 33.6527Z",
    fill: "#B1895C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3632 23.0731L66.9018 26.5616L69.1811 38.4237L37.5108 37.5942L35.3632 23.0731Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3284 37.4464C62.142 40.7724 59.2946 43.3175 55.9686 43.1311C52.6426 42.9448 50.0975 40.0974 50.2839 36.7714C50.4702 33.4454 53.3176 30.9002 56.6436 31.0866C59.9696 31.273 62.5148 34.1204 62.3284 37.4464Z",
    fill: "#7140FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2465 34.2628C56.8281 34.2954 57.332 34.4377 57.7581 34.6897C58.1896 34.9419 58.5124 35.2862 58.7266 35.7226C58.9465 36.1539 59.0408 36.6472 59.0097 37.2024C58.9786 37.7576 58.8297 38.2373 58.5631 38.6414C58.302 39.0405 57.943 39.3413 57.4861 39.5437C57.0345 39.7465 56.5179 39.8316 55.9362 39.799L54.001 39.6906L54.3112 34.1544L56.2465 34.2628ZM55.9495 38.8529C56.5311 38.8855 56.9895 38.7521 57.3245 38.4526C57.6595 38.1531 57.8432 37.7152 57.8755 37.1389C57.9078 36.5625 57.7744 36.1042 57.4752 35.7638C57.1763 35.4182 56.736 35.2291 56.1544 35.1965L55.3692 35.1525L55.1643 38.8089L55.9495 38.8529Z",
    fill: "white",
    fillOpacity: 0.93
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2242 24.2018C34.9739 23.5544 35.5005 22.8747 36.1894 22.9559L66.3364 26.5085C66.6666 26.5474 66.9508 26.7611 67.08 27.0678L70.9282 36.1999C71.1885 36.8178 70.7243 37.4966 70.0547 37.4773L40.6365 36.6291C40.2648 36.6184 39.9354 36.3854 39.8012 36.0384L35.2242 24.2018Z",
    fill: "#F2C491"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2615 36.9234L62.3456 37.2562C61.3126 34.3364 58.3256 31.9564 55.2575 31.7553C52.0266 31.5435 49.8728 33.8244 50.2615 36.9234Z",
    fill: "#8257FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1303 34.8268C56.6428 34.5842 56.1065 34.4476 55.5215 34.4169L53.5747 34.3149L54.146 37.0401L55.2571 37.0707L54.8811 35.2767L55.6709 35.3181C56.256 35.3488 56.7413 35.5307 57.1268 35.8639C57.5001 36.1824 57.7472 36.6087 57.8679 37.1425L59.0024 37.1738C58.8856 36.669 58.6704 36.2185 58.357 35.8223C58.032 35.4015 57.6231 35.0697 57.1303 34.8268Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDormit);
export default __webpack_public_path__ + "static/media/dormit.baaf305bdc91260fd7daa26c445a9da7.svg";
export { ForwardRef as ReactComponent };